// Ce fichier désactive les console.log en production
// mais les conserve en développement

// Sauvegarde des fonctions console originales
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug
};

// Fonction qui vérifie si nous sommes en production
const isProduction = () => {
  return process.env.NODE_ENV === 'production';
};

// Fonction de remplacement vide
const noOp = () => {};

// Désactiver les console.log en production
if (isProduction()) {
  console.log = noOp;
  // Optionnel: désactiver d'autres méthodes console
  // console.info = noOp;
  // console.debug = noOp;
  
  // En général, il est préférable de conserver les erreurs et avertissements
  // console.warn = noOp;
  // console.error = noOp;
}

// Exposer une méthode pour forcer le logging même en production
// Utile pour les messages très importants
console.forcelog = function() {
  originalConsole.log.apply(console, arguments);
};

export default {
  enableAllLogs: () => {
    console.log = originalConsole.log;
    console.warn = originalConsole.warn;
    console.error = originalConsole.error;
    console.info = originalConsole.info;
    console.debug = originalConsole.debug;
  },
  disableAllLogs: () => {
    console.log = noOp;
    console.warn = noOp;
    console.error = noOp;
    console.info = noOp;
    console.debug = noOp;
  },
  // Réactiver uniquement les logs
  enableLogs: () => {
    console.log = originalConsole.log;
  }
};